import { colors } from '../tokens';
import type { ProgressRingSize } from '../definitions/progress-ring';

export const progressRingSizes: Record<ProgressRingSize, { size: number; strokeWidth: number }> = {
  sm: { size: 28, strokeWidth: 4 },
  md: { size: 92, strokeWidth: 10 },
};

export const clampProgress = (value: number): number => Math.min(Math.max(value, 0), 100);

export const getProgressRingGeometry = ({
  value,
  size,
  strokeWidth,
}: {
  value: number;
  size: number;
  strokeWidth: number;
}) => {
  const clamped = clampProgress(value);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashoffset = circumference - (clamped / 100) * circumference;

  return {
    clamped,
    radius,
    circumference,
    dashoffset,
  };
};

export const progressRingColors = {
  progress: colors.primary.DEFAULT,
  track: colors['blue-accent'] ?? colors.primary.DEFAULT,
};
